import React, { memo, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from 'antd';
import { useRequestFilterCommands } from '../../../../model/commandsContext';
import {
  createOptionsForRender,
  optionCreators,
  useSetFilterChanged,
} from '../lib/utils';
import styles from '../SelectRoomsRow.module.scss';
import { compactMultiSelectTagProps } from '../../../primitives/selectTagProps';

const selectTypeFlatValue = (state) => state.filterStore.valueAddrTypeFlat;

const SelectRoom = ({
  value,
  getPopupContainer,
  gridRooms,
  rooms,
  showRooms,
}) => {
  const dispatch = useDispatch();
  const { setAddrFlatValue } = useRequestFilterCommands();

  const setFilterChanged = useSetFilterChanged();

  const handleChange = (value) => {
    dispatch(setAddrFlatValue(value));
    setFilterChanged();
  };

  const typeFlatValue = useSelector(selectTypeFlatValue);

  const gridOptions = useMemo(
    () =>
      createOptionsForRender({
        items: gridRooms,
        createOption: optionCreators.room,
        filtered: true,
        valueFiltered: typeFlatValue,
      }),
    [gridRooms, typeFlatValue]
  );

  const options = useMemo(
    () =>
      createOptionsForRender({
        items: rooms,
        createOption: optionCreators.room,
        filtered: true,
        valueFiltered: typeFlatValue,
      }),
    [rooms, typeFlatValue]
  );

  return (
    <Select
      {...compactMultiSelectTagProps}
      mode="multiple"
      allowClear={true}
      getPopupContainer={getPopupContainer}
      placeholder="Помещения"
      optionFilterProp="searchtext"
      style={{ width: 234, marginTop: '20px' }}
      value={value}
      onChange={handleChange}
      dropdownClassName={styles.dropdownCN}
      optionLabelProp="label"
    >
      {showRooms && options}
      {gridOptions}
    </Select>
  );
};

export default memo(SelectRoom);
